/*
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-12 14:31:37
 * @LastEditors: zh
 * @LastEditTime: 2021-12-09 15:51:28
 */
import work from '../../components/work/work'
import workChance from '../../components/workChance/workChance'

export default ({
    data() {
        return {
            currentMenu: '',
        }
    },
    created() {
        var route = this.$route.path
        this.currentMenu = route
    },
    components: { work, workChance },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
            if(page == '/join/work' && route != '/join/work') {
                this.$router.push({path:'/join/work'})
            }else if(page == '/join/workChance' && route != '/join/workChance'){
                this.$router.push({path:'/join/workChance'})
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/join/join.vue.js